import {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { useLoginMutation } from "../../../api/LoginAPI";
import useSignInStore from "../../../store/SignInStore";

const SignInPage = () => {
    const navigate = useNavigate();
    const {
        loginId,
        password,
        isLoading,
        error,
        setId,
        setPassword,
        setLoading,
        setError,
        resetForm,
        setLoggedIn,
    } = useSignInStore();
    const loginMutation = useLoginMutation();
    const [rememberMe, setRememberMe] = useState(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const oauth2Error = urlParams.get("oauth2error");
        const provider = urlParams.get("provider"); // 👈 signupType 같이 받기

        if (oauth2Error) {
            // 저장 후 URL 정리
            localStorage.setItem("oauth2Error", oauth2Error);
            if (provider) {
                localStorage.setItem("oauth2Provider", provider);
            }
            window.history.replaceState({}, document.title, "/login");
        }

        const savedError = localStorage.getItem("oauth2Error");
        const savedProvider = localStorage.getItem("oauth2Provider");

        if (savedError === "alreadyexist" && savedProvider) {
            alert(decodeURIComponent(provider));
            localStorage.removeItem("oauth2Error");
            localStorage.removeItem("oauth2Provider");
            window.history.replaceState({}, document.title, "/login");
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const result = await loginMutation.mutateAsync({
                loginId,
                password,
            });
            if (rememberMe) {
                localStorage.setItem("authToken", result.token);
                localStorage.setItem("userId", result.userId);
            }
            setLoggedIn(true);
            resetForm();
            navigate("/");
        } catch (error) {
            console.error("로그인 실패:", error);

            setError(
                // error.message || "로그인에 실패했습니다. 다시 시도해 주세요."
                "로그인에 실패했습니다. 다시 시도해 주세요."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-white px-4 py-12 sm:px-6 lg:px-8">
            <div className="w-full max-w-md space-y-8">
                <div className="text-center">
                    <button onClick={() => navigate("/")}>
                        <img
                            className="mx-auto height-15 w-auto"
                            src="/images/softcat_new_logo.png"
                            alt="Logo"
                        />
                    </button>
                </div>
                <form onSubmit={handleSubmit} className="mt-8 space-y-6">
                    <div className="space-y-4">
                        <div>
                            <input
                                type="text"
                                id="loginId"
                                value={loginId}
                                onChange={(e) => setId(e.target.value)}
                                placeholder="아이디"
                                className="block h-[60px] w-full rounded-lg border border-gray-300 px-4 py-3 text-gray-900 placeholder-gray-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                                required
                            />
                        </div>
                        <div>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="비밀번호"
                                className="block h-[60px] w-full rounded-lg border border-gray-300 px-4 py-3 text-gray-900 placeholder-gray-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                                required
                            />
                        </div>
                    </div>
                    <div className="flex items-center">
                        <input
                            id="remember"
                            name="remember"
                            type="checkbox"
                            checked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)}
                            className="h-4 w-4 rounded border-blue-300 text-blue-600 focus:ring-blue-500"
                        />
                        <label
                            htmlFor="remember"
                            className="ml-2 block text-sm text-gray-900"
                        >
                            로그인 유지
                        </label>
                    </div>
                    {error && (
                        <div className="text-sm text-red-600">{error}</div>
                    )}
                    <button
                        type="submit"
                        disabled={isLoading || !loginId || !password}
                        className={
                            isLoading || !loginId || !password
                                ? "w-full h-[60px] rounded-lg bg-gray-400 px-4 py-3 text-white hover:bg-gray-500-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50"
                                : "w-full h-[60px] rounded-lg bg-blue-600 px-4 py-3 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50"
                        }
                    >
                        {isLoading ? "로그인 중..." : "로그인"}
                    </button>
                    <div className="flex items-center justify-center space-x-3 text-sm text-gray-600">
                        <button
                            type="button"
                            onClick={() => navigate("/find-id")}
                            className="hover:text-blue-600"
                        >
                            아이디 찾기
                        </button>
                        <span className="text-gray-300">|</span>
                        <button
                            type="button"
                            onClick={() => navigate("/find-pw")}
                            className="hover:text-blue-600"
                        >
                            비밀번호 찾기
                        </button>
                        <span className="text-gray-300">|</span>
                        <button
                            type="button"
                            onClick={() => navigate("/signup")}
                            className="hover:text-blue-600"
                        >
                            회원가입
                        </button>
                    </div>
                    {/* 소셜로그인
                    이미지 추가해야함 */}
                    <div className="relative">
                        <div className="absolute inset-0 flex items-center">
                            <div className="w-full border-t border-gray-300" />
                        </div>
                        <div className="relative flex justify-center text-sm">
                            <span className="bg-gray-50 px-2 text-gray-500">
                                SNS 간편 로그인
                            </span>
                        </div>
                    </div>
                    <div className="mt-6 flex justify-center space-x-4">
                        <button
                            type="button"
                            className="rounded-full p-2 hover:bg-gray-100"
                            onClick={() => {
                                window.location.href = "http://localhost:8080/oauth2/authorization/naver";
                            }}
                        >
                            <img
                                src="/images/naver_icon.png"
                                alt="Naver"
                                className="h-10 w-10"
                            />
                        </button>
                        <button
                            type="button"
                            className="rounded-full p-2 hover:bg-gray-100"
                            onClick={() => {
                                // 추후 카카오 설정 후 적용
                                window.location.href = "http://localhost:8080/oauth2/authorization/kakao";
                            }}
                        >
                            <img
                                src="/images/kakako_icon.png"
                                alt="Kakao"
                                className="h-10 w-10"
                            />
                        </button>
                        <button
                            type="button"
                            className="rounded-full p-2 hover:bg-gray-100"
                            onClick={() => {
                                // 추후 구글 설정 후 적용
                                // window.location.href = "http://localhost:8080/login/oauth2/code/google";
                                alert("구글 로그인은 현재 준비중입니다. 불편을 드려서 죄송합니다.");
                            }}
                        >
                            <img
                                src="/images/google_icon.png"
                                alt="Google"
                                className="h-10 w-10"
                            />
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SignInPage;
